import React from 'react'
import ActionMenu from 'components/ActionMenu'
import { InfoBubbleIcon } from 'images/common'

const IncidentChartMenu = ({ onExplain, closeMenu }) => {
  return (
    <div>
      <ActionMenu
        onClick={() => {
          onExplain()
          closeMenu()
        }}
        icon={<InfoBubbleIcon />}
        text={'Explain my KPI'}
      />
    </div>
  )
}

export default IncidentChartMenu